/*jshint ignore:start*/
(function() {

	function Analytics() 
	{
		cm.analytics = this;

		this.numberOfRoundsStarted = 0;
        this.gameName = "Game_Elmo and Abby's Dress Up Time";
	}

	var p = Analytics.prototype;

	
	p.launchEvent = function() 
	{
		this.launchTime = Date.now();
		this.event('launch', cm.analytics.gameName, null);
	};


	p.event = function(action, label, value) 
	{

		console.log('TRACKING: ', action, label, value);
        cm.app.googleAnalytics.event(cm.analytics.gameName, action, label, value);

	};

	p.startRound = function(location, challengeSet) 
	{
		this.numberOfRoundsStarted++;
		this.roundStartTime = Date.now();

		if (challengeSet)
		{
			this.event('LevelSetStart', location + '_' + challengeSet, null);
		}
		else 
		{
			this.event('LevelSetStart', location, null);
		}

	};

	p.endChallengeRound = function(location, challengeSet, costume, numHints, numWrongAnswers)
	{
		var locChall = location + '_' + challengeSet;
		this.event('LevelSetComplete', locChall, null);
		this.event('LevelSetCompleteInfo', locChall + '_Time', Date.now() - this.launchTime);
		this.event('LevelSetCompleteInfo', locChall + '_' + costume, null);
	
		this.event('GameSUCCESS', locChall + '_Hints_' + numHints, null);
		this.event('GameSUCCESSInfo', locChall + '_NumWA_' + numWrongAnswers, null);
		this.event('GameSUCCESSInfo', locChall + '_TimeToComplete_' + (Date.now() - this.roundStartTime)/1000, null);

	};

	p.endDancingRound = function(location, danceButtonPresses, sfxButtonPresses)
	{
		this.event('LevelSetComplete', location, null);
		this.event('LevelSetCompleteInfo', location + '_Time', Date.now() - this.launchTime);
		
		var didPress = danceButtonPresses > 0 ? 'YES' : 'NO';
		this.event('ButtonSelectionDancePlay', 'Dancing Buttons_' + didPress, danceButtonPresses);

		didPress = sfxButtonPresses > 0 ? 'YES' : 'NO';
		this.event('ButtonSelectionDancePlay', 'Special Effects Buttons_' + didPress, sfxButtonPresses);
	};

	p.menuButtonPressed = function(location, challengeSet) 
	{
		var time = Date.now() - this.roundStartTime;
		if (challengeSet)
		{
			this.event('NavigationHome', location + '_' + challengeSet, time);
		}
		else 
		{
			this.event('NavigationHome', location, time);
		}
	};

	p.challengeRightAnswer = function(location, challengeSet, piece, hintNum, timeFromHint) 
	{
		var locChall = location + '_' + challengeSet;
		this.event('QuestionCA', locChall + '_Piece' + piece + '_Hints_' + hintNum, timeFromHint);
	};

	p.challengeWrongAnswer = function(location, challengeSet, hintNum, timeFromHint) 
	{
		var locChall = location + '_' + challengeSet;
		this.event('QuestionWA', locChall + '_Hints_' + hintNum, timeFromHint);
	};

	p.timeoutFired = function(location, challengeSet)
	{
		if (!this.firstTimeoutTimestamp)
		{
			this.firstTimeoutTimestamp = Date.now();
		}

		var locChall = _makeLocChallString(location, challengeSet);
		this.event('TimeoutPlay', locChall, null);
	};

	p.userReengage = function(location, challengeSet) 
	{
		if (this.firstTimeoutTimestamp)
		{
			var locChall = _makeLocChallString(location, challengeSet);
			this.event('TOReEngage', locChall, Date.now() - this.firstTimeoutTimestamp);
			this.firstTimeoutTimestamp = null;
		}
	};

	p.quitGame = function(location, challengeSet)
	{

		if (challengeSet)
		{
			this.event('Quit', location + '_' + challengeSet, null);
		}
		else 
		{
			this.event('Quit', location, null);
		}

		this.event('QuitInfo', 'GameDuration', Date.now() - this.launchTime);
		this.event('QuitInfo', 'LevelsVisited_' + this.numberOfRoundsStarted, this.numberOfRoundsStarted);
	};


	function _makeLocChallString(location, challengeSet) {
		var locChall;

		if (challengeSet)
		{
			locChall = location + '_' + challengeSet;
		}
		else 
		{
			locChall = location;
		}
		return locChall;
	};

	new Analytics();

})();
/*jshint ignore:end*/